import React, { useState } from 'react';

/*
import AppFR from './App_fr';
import AppEN from './App_en';
*/
import HomeFr from './HomeFr';
import HomeEn from './HomeEn';

function App() {
    
    

    
  const [lang, setLang] = useState('fr');

  return (
    <div className="App">
      {lang === 'fr' ? (
        <HomeFr onSwitchLanguage={() => setLang('en')} />
      ) : (
        <HomeEn onSwitchLanguage={() => setLang('fr')} />
      )}
    </div>
  );
}

export default App;
